import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { getBranding } from '../lib/branding';
import { moduleAccueil } from '../lib/permissions';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const { signIn, activer, bootstrap } = useAuth();
  const navigate = useNavigate();
  const b = getBranding();

  const submit = async (e) => {
    e.preventDefault();
    if (envoi) return;
    setError('');
    setEnvoi(true);
    try {
      const { error: err, role } = await (bootstrap ? activer(email, password) : signIn(email, password));
      if (err) {
        setError(err);
        return;
      }
      navigate(moduleAccueil(role), { replace: true });
    } catch (exc) {
      setError(`Connexion impossible : ${exc?.message ?? 'erreur inattendue'}`);
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <div data-testid="login-page" className="flex min-h-screen w-full bg-white">
      <div className="flex w-full flex-col justify-center px-6 py-10 sm:px-12 lg:w-[52%] lg:px-16">
        <div className="mb-8 flex items-center gap-3">
          {b.loginLogo || b.logo ? (
            <img data-testid="login-logo" src={b.loginLogo || b.logo} alt="Logo" className="h-16 w-16 object-contain" />
          ) : (
            <div className="flex h-9 w-9 items-center justify-center bg-slate-900 font-heading text-sm font-black text-white">OL</div>
          )}
          <div className="leading-tight">
            <p data-testid="login-nom" className="font-heading text-sm font-black tracking-tight text-slate-900">{b.nom}</p>
            <p className="font-data text-[10px] uppercase tracking-[0.12em] text-slate-500">{b.slogan}</p>
          </div>
        </div>

        <h1 className="font-heading text-3xl font-black tracking-tight text-slate-900">
          {bootstrap ? 'Activation initiale' : 'Connexion'}
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          {bootstrap
            ? 'Aucun compte n’existe encore sur ce serveur. Saisissez l’email propriétaire déclaré et choisissez votre mot de passe administrateur (10 caractères minimum, majuscules, chiffres ou symboles).'
            : 'Accès réservé aux comptes déclarés par l’administrateur.'}
        </p>

        <form onSubmit={submit} className="mt-6 max-w-md space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 h-11 w-full border border-slate-300 bg-slate-50 px-3 font-data text-sm outline-none transition-colors duration-150 focus:border-slate-900 focus:bg-white"
            />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.1em] text-slate-500">Mot de passe</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 h-11 w-full border border-slate-300 bg-slate-50 px-3 font-data text-sm outline-none transition-colors duration-150 focus:border-slate-900 focus:bg-white"
            />
          </div>

          {error && (
            <p data-testid="login-error" className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</p>
          )}

          <button
            data-testid="login-submit-button"
            type="submit"
            disabled={envoi}
            className="h-11 w-full bg-slate-900 font-heading text-sm font-bold uppercase tracking-[0.08em] text-white transition-colors duration-150 hover:bg-slate-700 disabled:cursor-not-allowed disabled:bg-slate-400"
          >
            {envoi ? 'Connexion…' : bootstrap ? 'Activer et définir mon mot de passe' : 'Se connecter'}
          </button>
        </form>
      </div>

      <div className="relative hidden lg:block lg:w-[48%]">
        <img data-testid="login-fond" src={b.loginFond} alt="Unité industrielle" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-slate-900/25" />
      </div>
    </div>
  );
}
